import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import styled from 'styled-components';
import {Line} from 'react-chartjs-2';
import {Box, MainHeading, BoxContent, NoData} from '../../StyledComponents';


/**
* Colors
*/
const themeColors = ['#9674a0', '#d26565', '#add3fb', '#55ba9a', '#1865bd', '#f07839', '#7b4172', '#e7969c', '#a55094', '#843c39'];


const BarChartViewContainer = styled.div`

`;

const BarChartContainer = styled.div`
  @media only screen and (max-width: 767px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

const ChartDescription = styled.h4`
  text-align: left;
  color: #929698;
  padding-left: 12%;
  padding-right: 12%;
  margin-bottom: 30px;

  @media only screen and (max-width: 767px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

const ChartDataContainer = styled.div`

`;

const ChartContainer = styled.div`
  flex: 1;
`;

const DataContainer = styled.div`
  @media only screen and (max-width: 767px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

const DataInnerContainer = styled.div`
  width: 50%;
`;

const IconRow = styled.div`
  margin-bottom: 8px;
`;

const IconData = styled.div`
  margin-right: 5px;
  height: 12px;
  width: 12px;
  border-radius: 50% !important;
  display: inline-block;
  float:left;
`;

const TitleData = styled.p`
  color: #c3c3c3;
  margin-bottom: 0;
  line-height: 12px;
  font-size:10px;
  text-transform: uppercase;
`;

/**
* Class BarChartView
*/
class LineChartView extends Component {

  constructor(props) {
    super(props)
    this.translateData = this.translateData.bind(this);
    this.renderChartData = this.renderChartData.bind(this);
  }


  renderChartLegend(data) {
    let values = data.datasets;
    let inactiveVars = this.state && this.state.inactiveVars ? this.state.inactiveVars : [];

    return _.map(values, (dataValue, key) => {
      if (inactiveVars.indexOf(dataValue.label) > -1) {
        return false;
      };
      return (
        <DataInnerContainer key={key}>
          <IconRow>
            <IconData style={{backgroundColor: dataValue.color}}></IconData>
            <TitleData>{dataValue.label}</TitleData>
          </IconRow>
        </DataInnerContainer>
      );
    });
  }

  translateData(data) {
    let series = {};
    const skipCols = 2;
    let timeLabels = [];
    _.each(data.data, function(row, outerI) {
      timeLabels.push(row[1].value);
      _.each(row, function(col, innerI) {
        if (innerI >= skipCols && col.value) {
          if (!series[innerI]) {
            series[innerI] = [col.value]
          } else {
            series[innerI].push(col.value);
          }
        }
      })
    })

    let datasets = [];
    let i = 0;
    for (var key in series) {
      if (series.hasOwnProperty(key)) {
        let timedata = series[key];
        let options = {"label":data.labels[i],"color":themeColors[i],"borderColor":themeColors[i], "pointBackgroundColor":themeColors[i],"fill":false};
        datasets.push({data: timedata, ...options});
      }
      i++;
    }

    const dataOut = {
      labels: timeLabels, //data.labels,
      datasets: datasets
    }

    return dataOut;
  }

  renderChartData(data) {
    let values = data.values;
    return _.map(values, (dataValue, key) => {
      return (
        <DataInnerContainer key={key}>
          <IconRow>
            <IconData style={{backgroundColor: themeColors[key] }}></IconData>
            <TitleData>{dataValue.name}</TitleData>
          </IconRow>
        </DataInnerContainer>
      );
    });
  }

  render() {
      const { data, printBreak } = this.props;
      const disabledViews = (this.props.user.client && this.props.user.client.viewSettings && this.props.user.client.viewSettings.disabledViews) || [];
      const _data = data;

      if (!data) {
        return <Box/>;
      };


      const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },

        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              fontColor: '#fff',
              fontSize: 10,
            },
            gridLines: {
              color: '#333333',
              zeroLineColor: '#333',
              lineWidth: 0.5,
            }
          }],
          xAxes: [{
            display: true,
            ticks: {
              fontColor: '#fff',
              fontSize: 10,
            }
          }]
        },
        elements: {
          line: {
            tension: 0,
            borderWidth: 1,
          }
        },
        animation: {
          duration:0
        }
      }


      const disabled = !data || disabledViews.indexOf(this.props.id) > -1;
      const chartData = _data ? this.translateData(_data) : {};

      return (
        <Box className={printBreak ? 'print-page-break-after' : ''} {...this.props}>
          <BarChartViewContainer>
              <MainHeading>{disabled ? (this.props.title || _data.title):_data.title}</MainHeading>
            <BoxContent disabled={disabled}>
            <BarChartContainer>

              <ChartDescription>{_data && _data.description}</ChartDescription>

              {_data && (
                <ChartDataContainer className="row">
                  <DataContainer className="col-xs-12 col-sm-12 col-md-12">
                   {this.renderChartLegend(chartData)}
                 </DataContainer>
                  <ChartContainer className="col-xs-12 col-sm-12 col-md-12">
                    <Line data={chartData} options={chartOptions} />
                  </ChartContainer>
                </ChartDataContainer>
              )}

            </BarChartContainer>
            </BoxContent>
            {disabled && <NoData/>}

          </BarChartViewContainer>
        </Box>
      );

  }
}

function mapStateToProps(state, ownProps) {
    return {
        uid: state.user.uid,
        user: state.user
    };
}

export default connect(mapStateToProps)(LineChartView);



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/LineChartView.js